import {PAGE_LIMIT} from '../constant'
import {get, post} from "../APIGateWay";

export async function getConfigs(params = {}) {
    params.page = params.page || 1;
    params.limit = params.limit || PAGE_LIMIT;
    return await get(params, '/cms/config')
}

export async function updateConfigs(data) {
    return await post(data, '/cms/config/update')
}

export async function getCountries(params = {}) {
    params.page = params.page || 1;
    params.limit = params.limit || PAGE_LIMIT;
    return await get(params, '/parent/list-country')
}

export async function getProvinces(params = {}) {
    params.page = params.page || 1;
    params.limit = params.limit || PAGE_LIMIT;
    return await get(params, '/parent/list-province')
}

export async function getWards(params = {}) {
    params.page = params.page || 1;
    params.limit = params.limit || PAGE_LIMIT;
    return await get(params, '/parent/list-ward')
}